var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0033AD;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_00000160868793401638407600000006599014937938239677_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.9,438.7c-1.2,20.8,14.8,38.6,35.6,39.8c0.7,0,1.5,0,2.2,0c20.9,0,37.8-16.9,37.7-37.8 c0-20.9-16.9-37.8-37.8-37.7C331.6,403,315,418.7,313.9,438.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M173,429c-6.7-0.4-12.6,4.8-12.9,11.5c-0.3,6.7,4.8,12.6,11.5,12.9c6.7,0.4,12.4-4.8,12.9-11.5 S179.7,429.5,173,429L173,429z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.5,219.4c6-3,8.4-10.5,5.4-16.5s-10.5-8.4-16.5-5.4s-8.4,10.3-5.4,16.3C298,220,305.4,222.6,311.5,219.4 C311.4,219.4,311.5,219.4,311.5,219.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M349.8,286.3c9.3-4.6,13-16,8.4-25.3c-4.6-9.3-16-13-25.3-8.4c-9.3,4.6-13,16-8.4,25.3 C329.2,287.2,340.5,290.9,349.8,286.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.9,332.2c7.2,4.6,16.8,2.7,21.5-4.5c4.6-7.2,2.7-16.8-4.5-21.5c-7.2-4.6-16.8-2.7-21.5,4.5l0,0 C211.6,317.9,213.7,327.6,220.9,332.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M243.7,422.3c-10.5-0.6-19.3,7.3-19.9,17.8s7.3,19.3,17.8,19.9c10.5,0.6,19.3-7.3,19.9-17.8l0,0 C262.1,431.9,254.2,422.9,243.7,422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223,549c-7.6,3.9-10.8,13.2-6.9,20.9c3.9,7.6,13.2,10.8,20.9,6.9c7.6-3.9,10.8-13.2,6.9-20.9l0,0 C240,548.2,230.6,545.1,223,549L223,549z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.3,383.2c10.3,6.7,24.1,3.9,30.7-6.4c6.7-10.3,3.9-24.1-6.4-30.7c-10.3-6.7-24.1-3.9-30.7,6.4 C283.1,362.7,285.9,376.5,296.3,383.2L296.3,383.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M528.9,284.8c8.7,5.7,20.5,3.3,26.2-5.4c5.7-8.7,3.3-20.5-5.4-26.2c-8.7-5.7-20.5-3.3-26.2,5.4l0,0 C517.6,267.5,520,279.1,528.9,284.8L528.9,284.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M567.5,218.2c5.7,3.7,13.2,2.1,16.9-3.6c3.7-5.7,2.1-13.2-3.6-16.9s-13.2-2.1-16.9,3.4 C560.3,206.9,561.9,214.5,567.5,218.2L567.5,218.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.7,402.7c-20.8-1.2-38.7,14.8-39.8,35.6c-1.2,20.8,14.8,38.7,35.6,39.8c0.7,0,1.5,0,2.1,0 c20.8,0,37.7-16.9,37.7-37.8C567.5,420.3,551.8,403.7,531.7,402.7L531.7,402.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.2,380.5c6.4,12.7,19.4,20.8,33.8,20.8c20.8,0,37.7-16.9,37.7-37.8c0-5.8-1.3-11.7-4-17.1 c-9.4-18.7-32.2-26.2-50.7-16.8C360.3,339.3,352.8,362,362.2,380.5L362.2,380.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M658.3,332.2c7.6-3.9,10.6-13.3,6.7-20.9c-3.9-7.6-13.3-10.6-20.9-6.7c-7.6,3.9-10.6,13.2-6.9,20.8 C641.2,333,650.5,336.1,658.3,332.2L658.3,332.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M562.5,344.2c-10.9,5.5-15.4,18.8-9.9,29.8c5.5,10.9,18.8,15.4,29.8,9.9c10.9-5.5,15.4-18.8,9.9-29.8 C586.8,343.1,573.4,338.8,562.5,344.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.1,212.6c8.5,0.4,15.9-6.1,16.5-14.7c0.6-8.5-6.1-15.9-14.7-16.5c-8.5-0.4-15.9,6-16.5,14.5 C424,204.6,430.6,212,439.1,212.6L439.1,212.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439,310.2c12.3,0.7,22.7-8.7,23.3-20.9c0.7-12.3-8.7-22.7-20.9-23.3c-12.3-0.7-22.7,8.7-23.3,20.9 C417.4,299.2,426.7,309.6,439,310.2L439,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318.7,537c10.9-5.5,15.4-18.8,9.9-29.8c-5.5-10.9-18.8-15.4-29.8-9.9c-10.9,5.5-15.4,18.8-9.9,29.8 C294.5,538.1,307.8,542.6,318.7,537z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M453.3,342.7c-11.4,17.5-6.6,40.8,10.9,52.2c17.5,11.4,40.8,6.6,52.2-10.9c11.4-17.5,6.6-40.8-10.9-52.2 c-6.1-4-13.3-6.1-20.6-6.1C472.2,325.6,460.4,332.1,453.3,342.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M519,500.7c-9.4-18.7-32.2-26.2-50.7-16.8c-18.7,9.4-26.2,32.2-16.8,50.7c9.4,18.7,32.2,26.2,50.7,16.8l0,0 c18.5-9.3,26.2-31.7,16.9-50.4C519.1,500.8,519.1,500.8,519,500.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585,498c-10.3-6.7-24.1-3.9-30.7,6.4c-6.7,10.3-3.9,24.1,6.4,30.7c10.3,6.7,24.1,3.9,30.7-6.4 C598.1,518.5,595.3,504.7,585,498L585,498z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.4,441.3c0.6-10.5-7.3-19.3-17.8-19.9c-10.5-0.6-19.3,7.3-19.9,17.8s7.3,19.3,17.8,19.9l0,0 C647.8,459.7,656.8,451.6,657.4,441.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M709.6,427.8c-6.7-0.4-12.6,4.8-12.9,11.5s4.8,12.6,11.5,12.9c6.7,0.4,12.4-4.8,12.9-11.5 C721.4,434,716.3,428.3,709.6,427.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M660.4,549c-7.2-4.6-16.8-2.7-21.5,4.5c-4.6,7.2-2.7,16.8,4.5,21.5c7.2,4.6,16.8,2.7,21.5-4.5 S667.5,553.6,660.4,549L660.4,549z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,663c-5.7-3.7-13.2-2.1-16.9,3.4c-3.7,5.7-2.1,13.2,3.4,16.9c5.7,3.7,13.2,2.1,16.9-3.4l0,0 C320.9,674.3,319.3,666.7,313.6,663z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.7,661.8c-6,3-8.4,10.5-5.4,16.5s10.5,8.4,16.5,5.4s8.4-10.3,5.4-16.3 C583.2,661.2,575.8,658.6,569.7,661.8C569.9,661.8,569.7,661.8,569.7,661.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M427.9,538.5c11.4-17.5,6.6-40.8-10.9-52.4c-17.5-11.4-40.8-6.6-52.4,10.9c-11.5,17.5-6.6,40.8,10.9,52.4 c6.1,4,13.3,6.1,20.6,6.1C409,555.7,420.9,549.3,427.9,538.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.3,596.4c-8.7-5.7-20.5-3.3-26.2,5.4c-5.7,8.7-3.3,20.5,5.4,26.2s20.5,3.3,26.2-5.4l0,0 C363.6,613.9,361.2,602.1,352.3,596.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.5,668.7c-8.5-0.4-15.9,6.1-16.5,14.7s6.1,15.9,14.7,16.5c8.5,0.4,15.9-6,16.5-14.5 C455.6,676.6,449,669.3,440.5,668.7L440.5,668.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.6,571c-12.3-0.7-22.7,8.7-23.3,20.9c-0.7,12.3,8.7,22.7,20.9,23.3c12.3,0.6,22.7-8.7,23.3-20.9 C462.3,582.2,452.9,571.6,440.6,571L440.6,571z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.4,594.9c-9.3,4.8-13,16.2-8.2,25.4c4.8,9.3,16.2,13,25.4,8.2c9.3-4.6,13-16,8.4-25.3 C552.2,594,540.8,590.1,531.4,594.9L531.4,594.9z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaIcon);
export default __webpack_public_path__ + "static/media/ada_icon.7ed4419f6d828343ce841ef6f37d0c13.svg";
export { ForwardRef as ReactComponent };